enum FileType {
    LAB = 1,
    ENCOUNTER = 2,
    DOCUMENT = 3, // Group of DocumentByte (18)
    MEDICALSUMMARY = 4,
    MEDICATIONSUMMARY = 5,

    // GrowthCurves DEPRECATED
    HEIGHTGRAPH = 6,
    WEIGHTGRAPH0TO2 = 7,
    WEIGHTGRAPH2PLUS = 8,
    BMIGRAPH = 9,
    HEADCIRCUMFERENCEGRAPH = 10,
    LENGTHGRAPH = 12,
    // --------------

    RADPDF = 11,
    LABPDF = 13,
    EXAMREQUEST = 14,
    CONSULTATIONREQUEST = 15,
    WORKERCLAIM = 16,
    ATTACHMENT = 17,
    DOCUMENTBYTES = 18, // Single Document File
    TemporaryFile = 19,
    OBSTETRICALFILE = 20,
    WorkSafeBcForm = 21,
    PatientGrowthChart,
    BatchScan,
    Prescription = 24,
    Invoice = 25,
    ImmunizationReport = 26,
    PrivateBilling = 27,

    // Only used for front end only.
    TemporaryFileForClinicians = 49,
    UNKOWN = 50 // Multiple file type merged together
}

export { FileType };
